<template>
    <section class="attachment-viewer-modal esesja-modal" ref="modal" tabindex="0" @keyup="keyPressed">
        <section class="esesja-modal__wraper">
            <section class="esesja-modal__wraper__body">
                <section class="attachment-viewer--header">
                    <button class="esesja-modal__wraper__header__exit-btn" @click="closeModal" style="background:#fff">
                        <img src="@/assets/icons/components/exit-btn.svg" />
                    </button>
                </section>
                <section class="attachment-viewer--modal--body">
                    <iframe :src="resolveIframeUrl()" style="border: none;" ref="modalIframe"></iframe>
                </section>
                <section class="download-section">
                    <button class="file-download-button" @click="download">{{$t('com.global.download')}}</button>
                </section>
            </section>
        </section>
    </section>
</template>
<script charset="utf-8">
    import esesjaInteractiveService from '../../../../../services/esesja.interactive.service';
    import alertsHelper from '../../../../../helpers/alerts.helper';
    import { fileDownloadHelperWithName } from "@/helpers/file.download.helper";

    export default {
        name: "AttachmentViewer",
        emits: ["close"],
        props: {
            title: {
                type: String,
                default: ''
            },
            pointId: {
                type: Number,
                required: true
            },
            attachmentId: {
                type: Number,
                required: true
            },
            fileData: {
                type: Object,
                require: true
            },
            filename: {
                type: String,
                require: true,
            },
            sessionId: {
                type: Number,
                require: true,
            }

        },
        watch:{
            '$refs.modalIframe':{
                deep: true,
                handler: function(e){
                    console.log("watch iframe", e)
                }
            }
        },
        data() {
            return {
                fileBlob: undefined,
                imageData: undefined,
                textData: undefined,
                fileType: {
                    isPfd: false,
                    isImage: false,
                    isText: false,
                },
                pdfFIle: this.attachmentId,
                isBusy: false,
            }
        },

        computed: {
            isInteractive() {
                return this.$store.state.appStore.isInInteractiveMode;
            },
        },
        async mounted() {
            if (this.pointId === -1) {
                return;
            }

            if (this.attachmentId === -1) {
                return;
            }

            window.addEventListener('message', this.receiveMessage, false);

            this.$refs.modal.focus();
        },
        methods: {
            receiveMessage(event) {

                if (event.data.closeModal === true) {
                    this.closeModal();
                    return;
                }

                if (event.data.scroolView !== undefined && event.data.scroolView !== null && event.data.scroolView > -1) {
                    this.scroolViewOw(event.data.scroolView);
                    return;
                }

                if (event.data.width !== undefined && event.data.height !== undefined) {
                    let maxWidth = window.document.documentElement.clientWidth * 0.9;
                    let maxHeight = window.document.documentElement.clientHeight * 0.9;

                    let isForce = false;
                    if (event.data.force !== undefined) {
                        isForce = event.data.force;
                    }
                    let newHeight = 0;
                    let newWidth = 0;
                    if (maxHeight >= event.data.height && maxWidth >= event.data.width) {
                        newHeight = event.data.height;
                        newWidth = event.data.width;
                    }
                    else {
                        let scaleX = maxWidth / event.data.width;
                        let scale = maxHeight / event.data.height;
                        if (scaleX < scale) {
                            scale = scaleX;
                        }
                        newHeight = event.data.height * scale;
                        newWidth = event.data.width * scale;
                    }
                    if (isForce) {
                        newWidth = event.data.width;
                        if (newWidth > maxWidth) {
                            newWidth = maxWidth
                        }
                    }
                    if (this.$refs.modalIframe !== null) {
                        this.$refs.modalIframe.style.width = `${newWidth}px`;
                        this.$refs.modalIframe.style.height = `${newHeight}px`;
                    }

                    if (isForce) {
                        this.changeScale(event.data.page, event.data.scale);
                    }

                    if (event.data.nextPage !== undefined && event.data.nextPage === true) {
                        this.nextPage(event.data.page, event.data.scale);
                    }

                    if (event.data.prevPage !== undefined && event.data.prevPage === true) {
                        this.prevPage(event.data.page, event.data.scale);
                    }
                }
            },
            resolveIframeUrl() {
                let routeResolve = this.$router.resolve({
                    name: 'AttachmentViewer',
                    params: { attachmentId: this.attachmentId },
                    query: {
                        sessionId: this.sessionId,
                        isInteractive: this.isInteractive,
                        pointId: this.pointId
                    }
                });
                return routeResolve.fullPath;
            },
            async closeModal() {
                window.removeEventListener("message", this.receiveMessage);
                let urlCreator = window.URL || window.webkitURL;
                if (this.fileType.isPfd) {
                    //this.fileBlob.destroy();
                    urlCreator.revokeObjectURL(this.fileBlob);
                    this.fileBlob = undefined;
                }
                else if (this.fileType.isImage) {
                    urlCreator.revokeObjectURL(this.imageData)
                }
                this.fileType.isPfd = false;
                this.fileType.isImage = false;
                this.fileType.isText = false;

                this.$emit('close')
            },

            scroolViewOw(percent) {
                if (this.isInteractive) {
                    esesjaInteractiveService.scroolAttachmentPage(this.sessionId, percent);
                }
            },

            prevPage(page, scale) {
                if (this.isInteractive) {
                    esesjaInteractiveService.changeAttachmentPage(this.sessionId, page, scale);
                }
            },

            nextPage(page, scale) {
                if (this.isInteractive) {
                    esesjaInteractiveService.changeAttachmentPage(this.sessionId, page, scale);
                }
            },

            changeScale(page, scale) {
                if (this.isInteractive) {
                    esesjaInteractiveService.changeAttachmentPage(this.sessionId, page, scale);
                }
            },

            async download() {
                try {
                    fileDownloadHelperWithName(this.fileData, this.filename);
                }
                catch {
                    var errorAlert = this.$swal.mixin(alertsHelper.errorToastElement());
                    errorAlert.fire(alertsHelper.errorToastAlert(this.$t('com.validation-error.download-file-error'), this.$t('com.global.error')));
                }
            },

            keyPressed(e) {
                if (!e.isTrusted) {
                    return;
                }
                if (e.key === undefined) {
                    return;
                }
                if (e.keyCode === undefined) {
                    return;
                }
                if (this.isBusy === true) {
                    return;
                }

                e.preventDefault();

                switch (e.keyCode) {
                    case 27:
                        this.closeModal();
                        break;
                }
            },
        }
    }
</script>
<style lang="scss" scope>
    @use "../../../../../assets/scss/esesja-modal.scss";


    .attachment-viewer-modal .esesja-modal__wraper {
        width: auto !important;
        height: auto !important;
        max-width: none !important;
        max-height: none !important;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .attachment-viewer-modal .esesja-modal__wraper__body {
        width: auto !important;
        height: auto !important;
        max-width: none !important;
        max-height: none !important;
        padding: 0px;
    }

    .download-section {
        display: flex;
        align-items: center;
        justify-content: center;

        .file-download-button {
            height: 52px;
            margin-left: 8px;
            background-color: white;
            border: 1px solid #bbc2ce;
            box-sizing: border-box;
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.2s ease-in-out;
            font-size: 1.2em;
            padding: 0px 15px;
            margin-bottom: 10px;

            &--small {
                width: 30px;
            }

            &:hover {
                background-color: #e8ebef;
            }
        }
    }
</style>